import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import InputPhone from "../../inputs/input-phone";
import { useAlert } from "../../../../services/alert";
import { useApiTenant } from "../../../../api/api-tenant";
export default function AudienceLeadForm({ campaignId, audienceId, isAddOpened, setIsAddOpened, setIsAdded, }) {
    const { t } = useTranslation();
    const api = useApiTenant();
    const alert = useAlert();
    const [phone, setPhone] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    useEffect(() => {
        if (phone) {
            setIsSaving(true);
            api.CREATE_audienceLead(campaignId, audienceId, phone.phone_area_id, phone.number)
                .then(() => {
                setIsSaving(false);
                setIsAddOpened(false);
                setIsAdded(true);
                alert.show(t("campaigns.audiences.leads.lead-form.added"), "success");
            })
                .catch(error => {
                setIsSaving(false);
                setIsAddOpened(false);
                console.error(error.response);
                if (error.response.status === 422) {
                    alert.show(error.response.data.message, "error");
                }
                else {
                    alert.show(t("campaigns.audiences.leads.lead-form.adding-error"), "error");
                }
            });
        }
    }, [phone]);
    return (_jsx(InputPhone, { type: "audience", setPhone: setPhone, isAddOpened: isAddOpened, setIsAddOpened: setIsAddOpened, isSaving: isSaving }));
}
